module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg29-99987244364fb47890d620a85153d7f0.jpg";